/* ARCHIVE fresh tiles (Ben, 2026-09-05): the homepage category tiles show a different
   photo from the email photo pool on every visit, so the front page never looks the same twice.
   Pool = shop metafield pmc.photos (the same 3:4 crops the popup uses, kept fresh by the
   popup-photos robot). Stable within one browsing session, new on the next. Labels and links
   are untouched. If the pool is missing or short, the tiles keep their set images. */
(function(){
  'use strict';
  var ov=document.getElementById('pmc-overlay'); if(!ov) return;
  var pool; try{ pool=JSON.parse(ov.getAttribute('data-photos')||'[]'); }catch(e){ return; }
  if(!Array.isArray(pool)||pool.length<8) return;
  var sec=document.querySelector('.m-image-cards'); if(!sec) return;
  var imgs=[].slice.call(sec.querySelectorAll('.m-media__wrapper img')); if(!imgs.length) return;
  var key='arc_tiles_v1', picks=null;
  try{ picks=JSON.parse(sessionStorage.getItem(key)||'null'); }catch(e){}
  if(!picks||picks.length<imgs.length){
    var idx=pool.map(function(_,i){return i;});
    for(var i=idx.length-1;i>0;i--){ var j=Math.floor(Math.random()*(i+1)); var t=idx[i]; idx[i]=idx[j]; idx[j]=t; }
    picks=idx.slice(0,imgs.length).map(function(i){ return pool[i]; });
    try{ sessionStorage.setItem(key,JSON.stringify(picks)); }catch(e){}
  }
  imgs.forEach(function(img,n){
    var url=picks[n]; if(!url) return;
    var pre=new Image();
    pre.onload=function(){
      // Phones: the theme wraps the tile in <picture> with a <source media="(max-width:767px)">,
      // and a <source> always beats the <img> src. Drop the sources so the swap shows on mobile too.
      var pic=img.parentNode; if(pic&&pic.tagName==='PICTURE'){ [].slice.call(pic.querySelectorAll('source')).forEach(function(s){ s.parentNode.removeChild(s); }); }
      img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src=url; img.style.objectFit='cover';
    };
    pre.src=url;
  });
})();
